import React from 'react';
import { isAdminUser, NoAccessMessage } from '../utils/permissionControl';
import useAdminPanelAuth from '../hooks/useAdminPanelAuth';
import useAdminPanelData from '../hooks/useAdminPanelData';
import AdminLoginForm from '../components/admin/AdminLoginForm';
import AdminPanelShell from '../components/admin/AdminPanelShell';
import { buildAdminPanelTabs } from './admin/buildAdminPanelTabs';
import './AdminPanel.css';

/**
 * 管理后台页面（AdminPanel.js）
 * 功能：用户管理、分组管理、权限点管理、分组授权、用户授权、公告管理、指挥系统密码管理
 * 技术栈：React + Ant Design
 * 说明：本页面为系统管理员提供所有后台管理功能，支持批量操作、搜索、权限联动等。
 */
function AdminPanel() {
  const auth = useAdminPanelAuth();
  const data = useAdminPanelData({
    token: auth.token,
    handleLogout: auth.handleLogout,
    authed: auth.authed
  });

  if (!auth.authed) {
    return (
      <AdminLoginForm
        username={auth.username}
        password={auth.password}
        loginError={auth.loginError}
        onUsernameChange={auth.setUsername}
        onPasswordChange={auth.setPassword}
        onLogin={auth.handleLogin}
      />
    );
  }

  const hasAdminAccess = auth.role === 'admin'
    || isAdminUser()
    || (Array.isArray(auth.userPermissions) && auth.userPermissions.includes('管理后台访问'));
  if (!hasAdminAccess) {
    return <NoAccessMessage permissionName="管理后台访问" />;
  }

  const tabItems = buildAdminPanelTabs({
    ...data,
    userPermissions: auth.userPermissions
  });
  const activeTab = tabItems.some((item) => item.key === data.tab)
    ? data.tab
    : (tabItems[0]?.key || data.tab);

  return (
    <AdminPanelShell
      adminName={auth.adminName}
      onLogout={auth.handleLogout}
      activeTab={activeTab}
      onTabChange={data.setTab}
      tabItems={tabItems}
    />
  );
}

export default AdminPanel;
